import { Editor } from 'tinymce';

import * as MergeTags from '../core/MergeTags';

const register = (editor: Editor): void => {
  editor.addCommand('dgInsertMergeTag', (ui: boolean, value: string) =>
    MergeTags.insertMergeTag(editor, ui, value)
  );
};

export { register };
